import styled from 'styled-components'

export const Content = styled.div`
  min-width: 80%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
`